import { Project } from '@constants/router.const';
import { Ng2StateDeclaration } from '@uirouter/angular';

export const BUDA_MODULE_STATE: Ng2StateDeclaration = {
  name: `dice.${Project.BUDA}.**`,
  url: '/buda',
  loadChildren: () => import('@buda/app/buda.module').then((m) => m.BudaModule),
};

export const APP_STATES = [BUDA_MODULE_STATE];
